import React, { useState } from "react";

/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import copy_icon from "../../assets/icons/copy_small.svg";
import { ReactComponent as CheckIcon } from "../../assets/check.svg";

import { shortenAddress } from "../../utils/shortenAddress";
import colors from "../../constants/colors";
import { MOBILE } from "../../constants/breakpoints";

const WalletInfoCopy = ({
  label_text,
  value,
  active_border = false,
}: {
  label_text: string;
  value: string;
  active_border?: boolean;
}) => {
  const [isCopying, setIsCopying] = useState(false)

  return (
    <span
      css={css`
        display: flex;
        width: 100%;
        align-items: center;
        width: 454px;
        height: 80px;
        border: ${active_border
          ? "3px solid " + colors.INTERFACE_COLORS_LAVABEE_YELLOW
          : "1px solid #ccc4b3"};
        border-radius: 12px;
        padding: 0 16px;
        background-color: white;

        @media (max-width: ${MOBILE}px) {
          width: 100%;
          margin: 0 auto;
        }
      `}
    >
      <span
        css={css`
          display: flex;
          min-width: 48px;
          height: 48px;
          margin-right: 8px;
        `}
      >
        {label_text == "Asset Wallet" ? (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.0999 20.1004C1.2999 14.8004 4.69989 9.4004 9.39989 6.3004C14.1999 3.1004 21.3999 3.2004 27.5999 3.8004C34.4999 4.5004 40.3999 6.9004 43.8999 12.1004C47.6999 17.9004 48.1999 26.4004 44.6999 32.0004C41.2999 37.4004 34.8999 39.8004 26.8999 40.0004C20.2999 40.2004 12.7999 39.8004 7.7999 35.6004C3.0999 31.7004 0.899895 25.6004 1.0999 20.1004Z"
              fill="#FFD550"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M26.1471 13.5915C25.7072 12.9721 25.0731 12.5241 23.9664 12.5978L23.9643 12.598C22.4498 12.6957 19.7053 13.0165 17.3121 13.3172C16.1214 13.4669 15.027 13.6103 14.2302 13.7163C13.8319 13.7693 13.5081 13.813 13.284 13.8433L12.9364 13.8907L12.935 13.8909C9.74835 14.3254 7.92846 15.2845 6.9628 16.6324C5.99218 17.9873 5.70277 19.9862 6.18672 22.9383C6.97716 27.7798 8.55857 34.0984 10.919 39.6061C11.5394 41.0536 12.6724 42.0108 14.2947 42.6067C15.9479 43.2139 18.0775 43.4302 20.5729 43.3629C24.8042 43.2488 29.8158 42.3352 34.8632 41.415C35.784 41.2471 36.706 41.079 37.6247 40.9155L37.6285 40.9148C39.7932 40.5384 40.8331 39.8692 41.409 39.0921C42.0137 38.2762 42.2529 37.1604 42.4023 35.5279L42.6999 29.9737C42.6966 28.1721 42.3551 27.0118 41.8116 26.3435C41.3193 25.7383 40.5168 25.3663 39.0904 25.4959L39.0847 25.4964C36.7894 25.6918 32.7419 26.3816 28.3596 27.1476C27.9515 27.2189 27.5408 27.2909 27.1287 27.3631C23.1556 28.0589 19.0534 28.7774 15.951 29.1888C13.6468 29.5816 11.5696 27.8327 11.3072 25.6208L10.8067 21.6169C10.5413 19.361 12.142 17.3706 14.383 17.1069L21.9823 16.207L22.0004 16.205C22.7201 16.133 23.3601 16.2965 23.8961 16.6432C24.4148 16.9787 24.7838 17.451 25.0484 17.9257C25.5628 18.8487 25.7827 19.9647 25.8882 20.7458C25.8875 20.7426 25.8869 20.7392 25.8863 20.7356L24.8999 20.9L25.8911 20.7679C25.8901 20.7606 25.8892 20.7532 25.8882 20.7458C25.8968 20.7883 25.911 20.8083 25.9171 20.8154C25.9124 20.8153 25.9132 20.8152 25.9132 20.8152C25.9161 20.8159 25.9198 20.8182 25.9198 20.8182C25.9198 20.8182 25.9196 20.8181 25.9171 20.8154C25.9209 20.8154 25.9269 20.8151 25.9355 20.8137C25.9454 20.812 25.9553 20.8105 25.9652 20.8092L36.2652 19.4092C36.8125 19.3348 37.3164 19.7181 37.3908 20.2654C37.4652 20.8126 37.0818 21.3166 36.5346 21.3909L26.2473 22.7892C26.253 22.7883 26.2586 22.7874 26.2643 22.7864L26.0999 21.8L26.2346 22.7909L26.2473 22.7892C25.0508 22.9793 24.0932 22.1425 23.9135 21.0644C23.9117 21.0537 23.9101 21.043 23.9087 21.0322C23.8129 20.3143 23.6321 19.4927 23.3014 18.8994C23.141 18.6116 22.9725 18.4277 22.8099 18.3225C22.666 18.2295 22.4832 18.1682 22.2073 18.1943L22.2175 18.1931L22.0999 17.2L22.1994 18.1951C22.202 18.1948 22.2047 18.1946 22.2073 18.1943L14.6175 19.0931C13.4597 19.2293 12.66 20.2372 12.7927 21.3799L12.7922 21.376L11.7999 21.5L12.793 21.3832L12.7927 21.3799L13.2931 25.3832C13.4318 26.5622 14.5406 27.4068 15.6261 27.2153C15.6402 27.2128 15.6544 27.2106 15.6687 27.2087C18.729 26.8037 22.7967 26.0913 26.7909 25.3918C27.2001 25.3201 27.6086 25.2485 28.0152 25.1775C32.3561 24.4187 36.5071 23.7089 38.9123 23.5039L38.9094 23.5042L38.9999 24.5L38.9151 23.5036L38.9123 23.5039C40.7846 23.3343 42.331 23.8125 43.3632 25.0816C44.342 26.285 44.6999 28.0167 44.6999 30C44.6999 30.0116 44.6997 30.0232 44.6993 30.0347C44.6991 30.041 44.6988 30.0473 44.6985 30.0535L44.3985 35.6535C44.3978 35.6659 44.3969 35.6783 44.3958 35.6906C44.2451 37.3481 43.9838 38.977 43.0158 40.283C42.017 41.6306 40.4075 42.4613 37.9733 42.8849L37.9751 42.8846L37.7999 41.9L37.9712 42.8853L37.9733 42.8849C37.0777 43.0443 36.1713 43.2097 35.2597 43.3761C30.222 44.2955 25.0269 45.2436 20.6268 45.3622C18.0223 45.4324 15.6019 45.2174 13.6051 44.484C11.5774 43.7393 9.96038 42.4465 9.08074 40.394C6.64124 34.7018 5.02256 28.2199 4.213 23.2614V23.2614C3.69708 20.1138 3.90769 17.4627 5.33698 15.4677C6.77125 13.4657 9.25118 12.3748 12.6643 11.9093V11.9093L13.0154 11.8614C13.2409 11.8309 13.5663 11.787 13.9664 11.7338C14.7665 11.6273 15.8659 11.4832 17.0627 11.3328C19.444 11.0336 22.2488 10.7045 23.8345 10.6022C25.7272 10.4764 26.9927 11.3282 27.7777 12.4335C28.5177 13.4756 28.8245 14.7249 28.9799 15.5008C28.9799 15.5008 28.9814 15.504 28.9832 15.5068V15.5068C28.9881 15.5062 28.993 15.5058 28.9979 15.5053L36.7877 14.7063C38.9666 14.4407 40.9326 16.0694 41.193 18.2832L41.1933 18.2854L41.4933 20.8854C41.5566 21.4341 41.1632 21.9302 40.6145 21.9935C40.0659 22.0568 39.5698 21.6633 39.5065 21.1147L39.2067 18.5169L39.2066 18.5155C39.0669 17.3341 38.0398 16.5653 37.0239 16.6923L37.0019 16.6948L29.2408 17.4908C28.1242 17.6805 27.2035 16.8172 27.0193 15.8962C26.8745 15.1719 26.6311 14.2731 26.1471 13.5915Z"
              fill="#191414"
            />
          </svg>
        ) : (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M43.6 34.0003C38.1 44.3003 14 42.6003 9.70005 37.8003C5.10005 32.6003 2.30005 27.3003 2.60005 20.9003C3.00005 13.8003 8.00005 8.20033 14.3 5.50033C20.4 2.80033 28 2.00033 34.6 6.50033C49.6 16.6003 46.3 28.8003 43.6 34.0003Z"
              fill="#FFD550"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M32.3526 33.1354C31.4812 34.8569 31.9439 37.0754 33.7151 37.972C35.4864 38.8685 37.5482 37.9277 38.4195 36.2063C39.2909 34.4848 38.8282 32.2662 37.057 31.3697C35.2857 30.4732 33.2239 31.4139 32.3526 33.1354ZM34.6183 36.1876C34.0244 35.8869 33.6615 34.9779 34.137 34.0386C34.6124 33.0992 35.5598 32.8534 36.1538 33.1541C36.7477 33.4547 37.1106 34.3637 36.6351 35.3031C36.1596 36.2424 35.2123 36.4882 34.6183 36.1876Z"
              fill="#191414"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.9441 6.20163C26.5322 5.88561 31.4113 9.99618 32.1258 15.4657C32.4217 15.4732 32.6597 15.4812 32.8316 15.4877C32.9338 15.4916 33.0127 15.495 33.0665 15.4974L33.1283 15.5003L33.1447 15.5011L33.1512 15.5014L33.1 16.5001C33.1512 15.5014 33.1516 15.5014 33.1512 15.5014C33.1756 15.5026 33.1999 15.5048 33.2241 15.5078C34.4217 15.6575 35.7834 15.8987 36.8209 16.5747C37.3633 16.9281 37.8314 17.408 38.1379 18.0544C38.4381 18.6874 38.5537 19.4172 38.4999 20.2363C38.4976 20.5354 38.4673 20.7992 38.4431 21.0049C38.416 21.2354 38.4 21.3712 38.4 21.5001C38.4 22.0524 37.9523 22.5001 37.4 22.5001C36.8477 22.5001 36.4 22.0524 36.4 21.5001C36.4 21.2496 36.4291 21.0049 36.4515 20.8159L36.4569 20.7707C36.4817 20.5597 36.5 20.386 36.5 20.2001C36.5 20.1763 36.5009 20.1525 36.5026 20.1288C36.543 19.5621 36.4577 19.1788 36.3309 18.9114C36.2061 18.6484 36.0117 18.4345 35.7291 18.2504C35.1231 17.8556 34.198 17.647 33.0136 17.4971L32.9769 17.4954C32.9275 17.4932 32.8531 17.49 32.7556 17.4863C32.6317 17.4816 32.4704 17.476 32.2751 17.4704L32.3975 19.4284C32.5408 21.2287 31.0588 22.8001 29.2 22.8001C26.4104 22.8001 21.6473 23.0036 18.1085 24.1513C17.5832 24.3217 17.0192 24.0339 16.8488 23.5086C16.6784 22.9832 16.9662 22.4192 17.4915 22.2488C21.3527 20.9966 26.3897 20.8001 29.2 20.8001C29.9373 20.8001 30.4531 20.1781 30.4035 19.5831L30.402 19.5624L30.2694 17.4417C29.8377 17.4411 29.3653 17.4438 28.8591 17.4515C26.3342 17.4902 22.9885 17.6542 19.6734 18.1515C17.3206 18.5044 15.029 19.0189 13.0704 19.7516L13.5829 26.3415C13.7169 26.6098 13.8723 26.8057 14.1972 26.9681C14.6409 27.19 15.5012 27.3946 17.2057 27.3037L17.7192 27.234C18.076 27.1854 18.5931 27.1148 19.234 27.0266C20.5158 26.8502 22.2925 26.6035 24.272 26.3225C28.2345 25.76 32.9977 25.0616 36.2332 24.5141L36.248 24.5117C37.9264 24.2535 39.4566 24.9424 40.5446 26.0305C41.6282 27.114 42.3396 28.6505 42.3993 30.2631L42.3997 30.2727L42.5994 37.5644L42.5995 37.5688C42.7186 40.9684 40.1517 43.4282 36.9488 43.889C36.5263 43.9554 36.0913 44.0246 35.6455 44.0954C31.4253 44.766 26.2406 45.5899 21.5744 45.7619C18.9923 45.8571 16.5135 45.7558 14.4105 45.2974C12.3258 44.8431 10.4723 44.0076 9.31458 42.5191C6.28498 38.7285 5.89733 34.6819 5.40167 26.0574L5.40153 26.055C5.22268 22.8058 7.16893 20.5518 9.82601 19.0471C10.1897 18.8411 10.57 18.647 10.9642 18.4641L10.903 17.6776L10.9027 17.6726C10.4621 11.6147 14.9868 6.53286 20.9441 6.20163ZM21.0565 8.19847C25.4962 7.94717 29.3916 11.1456 30.1006 15.4416C29.7058 15.4418 29.2802 15.4448 28.8285 15.4517C26.2534 15.4912 22.8115 15.6584 19.3767 16.1736C17.1712 16.5044 14.9302 16.984 12.9096 17.6842L12.8974 17.5275L12.8972 17.5252C12.5392 12.5843 16.2138 8.46751 21.0555 8.19853L21.0565 8.19847ZM10.8115 20.7874C10.9163 20.7281 11.0229 20.6698 11.1313 20.6124L11.603 26.6776C11.6119 26.7911 11.64 26.9022 11.6862 27.0062C11.9323 27.5598 12.3346 28.2729 13.3028 28.757C14.2057 29.2085 15.4858 29.4024 17.3555 29.2985C17.3817 29.2971 17.4084 29.2945 17.4343 29.291L17.989 29.2157C18.3467 29.167 18.8647 29.0963 19.5067 29.0079C20.7905 28.8312 22.5701 28.5841 24.5531 28.3026C28.5123 27.7406 33.2946 27.0396 36.5589 26.4874C37.4782 26.3484 38.3953 26.7095 39.1304 27.4447C39.8708 28.185 40.359 29.2465 40.4005 30.3323L40.4007 30.3371L40.6004 37.6275L40.6007 37.6358C40.6791 39.8313 39.0509 41.5683 36.6586 41.91L36.6446 41.9122C36.2202 41.979 35.7853 42.048 35.3413 42.1186L35.3387 42.119C31.0996 42.7922 26.0378 43.596 21.5007 43.7632C18.9952 43.8556 16.7053 43.7506 14.8364 43.3433C12.9521 42.9327 11.6329 42.2448 10.8902 41.2872L10.8809 41.2754C8.3148 38.0678 7.90251 34.7142 7.39845 25.9439C7.27781 23.7438 8.51903 22.0856 10.8115 20.7874ZM17.3 28.3001L17.4343 29.291C17.4342 29.291 17.4337 29.2911 17.3 28.3001Z"
              fill="#191414"
            />
          </svg>
        )}
      </span>
      <div
        css={css`
          display: flex;
          width: 100%;
          align-items: center;
        `}
      >
        <span
          css={css`
            display: flex;
            width: 100%;

            @media (max-width: ${MOBILE}px) {
              flex-direction: column;
            }
          `}
        >
          <p
            css={css`
              font-weight: 500;
              font-size: 16px;
              color: #757272;
              margin: 0;

              @media (max-width: ${MOBILE}px) {
                font-size: 14px;
              }
            `}
          >
            {label_text}
          </p>
          <span
            css={css`
              display: flex;
              flex-grow: 1;
              border: 1px dashed #a29b8b84;
              margin: 0 8px;
              margin-top: auto;
              margin-bottom: 5px;

              @media (max-width: ${MOBILE}px) {
                display: none;
              }
            `}
          ></span>
          <h1
            css={css`
              font-weight: 500;
              font-size: 16px;
              color: #191414;
              margin: 0;
              @media (max-width: ${MOBILE}px) {
                font-size: 14px;
              }
            `}
          >
            {shortenAddress(value ? value : "")}
          </h1>
        </span>
        {isCopying ?
          <CheckIcon
            css={css`
              margin-left: 5px;
              circle{
                fill: #96da96;
              }
              path{
                fill: #036403;
              }
            `}
          />
          : <img
            onClick={() => {
              navigator.clipboard.writeText(value);
              setIsCopying(true)
              setTimeout(() => {
                setIsCopying(false)
              }, 600);
            }}
            css={css`
            margin-left: 5px;
            cursor: pointer;
            &:hover {
              margin-left: 10px;
              transform: scale(1.2);
              transition: all 0.2s ease-in-out;
            }
          `}
            src={copy_icon}
            alt=""
          />
        }
      </div>
    </span>
  );
};

export default WalletInfoCopy;
